import {Layout} from "./Layout.js";

export class CompanyProfileLayout extends Layout {

    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <div id="companyNameLayer"></div>
                            <div id="companyCategorySelectLayer" class="select-wrap"> </div>
                            <div id="hopeCountSelectLayer" class="select-wrap"></div>
                            ${this.getServiceTypeTemplate()}
                            ${this.getNexPageButtonTemplate()}
                        </div>
                    </article>
                </section>`
    }
    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;
        return  Object.values(nextButton).length > 0  ?  `<button id = "${nextButton.id}" class="btn-next js-next-page-button" >${Mutil.n2v(nextButton.text)}</button>` : "";
    }
    getNextLinkTemplate() {
        const {nextLink = {}} = this.$props;
        return  Object.values(nextLink).length > 0  ?  `<a id = "${Mutil.n2v(nextLink.id)}" class="js-next-page-link comp-info-link" >${Mutil.n2v(nextLink.text)}</a>` : "";
    }
    getServiceTypeTemplate() {
        return `
            <div class="product-selection js-service-type-layer" style="display: none;"> 
                <p class="product-selection-title">상품유형을 선택해주세요.</p>
                <label class="product-group">
                    <input type="radio" name="radioOption" value="클라우드 도입문의" checked>
                    <span></span>
                    <div>
                        <p>구독형(클라우드)</p>
                        <span>중소, 중견 기업에 적합</span>
                    </div>
                </label> 
                <label class="product-group">
                <input type="radio" name="radioOption" value="구축상품 도입문의">
                <span></span>
                <div>
                    <p>구축형(엔터프라이즈)</p>
                    <span>대기업, 공공기관, 금융회사 등에 적합</span>    
                </div>
                </label>
            </div>
        `
    }
}